/* ANYSNIFF accordion (FAQ + product page).
 *
 * The original loaded @finsweet/attributes-accordion, but the accordion does not
 * open on the live Webflow site either — clicking a header leaves aria-expanded
 * false and the panel height unchanged. This is a working replacement built on
 * the same markup contract and the CSS that is already in the theme:
 *
 *   .prod_accordion_content        transition: max-height .2s; overflow: hidden
 *   .prod_accordion_arrow-wrapper  rotate(180deg), .is-active-accordion -> rotate(0)
 *
 * Attributes honoured: fs-accordion-element="group|accordion|trigger|content|arrow",
 * fs-accordion-initial="none" (start closed), fs-accordion-single="true" (one at a time).
 */
(function () {
  'use strict';

  var OPEN_CLASS = 'is-active-accordion';

  function parts(item) {
    return {
      trigger: item.querySelector('[fs-accordion-element="trigger"]'),
      content: item.querySelector('[fs-accordion-element="content"]'),
      arrow: item.querySelector('[fs-accordion-element="arrow"]')
    };
  }

  function setOpen(item, open) {
    var p = parts(item);
    if (!p.content) return;
    p.content.style.maxHeight = open ? p.content.scrollHeight + 'px' : '0px';
    if (p.trigger) p.trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (p.arrow) p.arrow.classList.toggle(OPEN_CLASS, open);
    item.classList.toggle('is-open', open);
  }

  function isOpen(item) {
    var t = parts(item).trigger;
    return t && t.getAttribute('aria-expanded') === 'true';
  }

  document.querySelectorAll('[fs-accordion-element="group"]').forEach(function (group) {
    var items = Array.prototype.slice.call(
      group.querySelectorAll('[fs-accordion-element="accordion"]'));
    if (!items.length) return;

    var single = group.getAttribute('fs-accordion-single') === 'true';
    var initial = group.getAttribute('fs-accordion-initial');

    items.forEach(function (item, i) {
      // Start closed unless the group asks for a specific one to be open.
      setOpen(item, initial !== 'none' && initial !== null && String(i) === String(initial));

      var p = parts(item);
      if (!p.trigger) return;

      function toggle(e) {
        e.preventDefault();
        var next = !isOpen(item);
        if (next && single) {
          items.forEach(function (other) { if (other !== item) setOpen(other, false); });
        }
        setOpen(item, next);
      }

      p.trigger.addEventListener('click', toggle);
      p.trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') toggle(e);
      });
    });

    // An open panel's pixel height goes stale when the layout reflows.
    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        if (isOpen(item)) {
          var c = parts(item).content;
          if (c) c.style.maxHeight = c.scrollHeight + 'px';
        }
      });
    });
  });
})();
